import PropTypes from "prop-types";
import styled from "styled-components";
export var Spinner = styled.div.withConfig({
  displayName: "Spinner"
})(["height:", "px;width:", "px;border-radius:50%;animation:rotation 1.5s linear infinite;border:", "px solid ", ";border-top:", "px solid ", ";@keyframes rotation{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}"], function (_ref) {
  var size = _ref.size;
  return size;
}, function (_ref2) {
  var size = _ref2.size;
  return size;
}, function (_ref3) {
  var width = _ref3.width;
  return width;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.secondary;
}, function (_ref5) {
  var width = _ref5.width;
  return width;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.border;
});
Spinner.propTypes = {
  size: PropTypes.number,
  width: PropTypes.number
};
Spinner.defaultProps = {
  size: 30,
  width: 4
};